import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const CourtDunningProcedure = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Court dunning procedure";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
